import React, { useEffect, useRef, useState } from "react";
import { DropDownArrowIconSvg } from "../../../../assets/svg";
import { Form } from "react-bootstrap";
import { getSpecialAddon } from "../../../../api/itinerary.api";
import "./style.scss";

export interface SpecialAddonItem {
  id: string;
  code: string;
  price: number;
  specification: string;
  name: string;
  approver_role: string;
  createdAt: string;
  updatedAt: string;
}
const SpecialAddon = ({ handleSumbmit, show }: any) => {
  const Droparget = useRef(null);
  const [isToggle, setIsToggle] = useState(false);
  const [isActive, setIsActive] = useState("paid");
  const [specialAddon, setSpecialAddon] = useState<SpecialAddonItem[]>([]);
  const [selectedSpecialAddon, setSelectedSpecialAddon] = useState<string[]>([]);

  useEffect(() => {
    fetchSpecialAddon();
  }, []);
    
  useEffect(() => {
      if (!show) setSelectedSpecialAddon([]);
  }, [show]);
    
  const fetchSpecialAddon = async () => {
    const data: any = await getSpecialAddon();
    if (data && data.status == 200) {
      setSpecialAddon(data?.result);
    }
  };

  return (
    <div className="my-2">
      <div className="select-addon" ref={Droparget} onClick={() => setIsToggle(prev => !prev)}>
        <div className="flex justify-between custom-select align-items-center">
          Select Add-ons &nbsp;
          <span>
            <DropDownArrowIconSvg />
          </span>
        </div>
      </div>

      {isToggle && (
        <div className="w-full border bg-white text-dark p-3 rounded mt-2">
          <div className="flex justify-between cursor-pointer">
            {/* <p className={isActive === "all" ? "addon-active" : ""} onClick={() => {}}>
              All
            </p> */}
            {/* <p className={isActive === "free" ? "addon-active" : ""} onClick={() => setIsActive("free")}>
              Free
            </p> */}
            <p className={isActive === "paid" ? "addon-active" : ""} onClick={() => setIsActive("paid")}>
              Paid
            </p>
          </div>
          {specialAddon?.map((item) => {
            return (
              <React.Fragment key={item?.id}>
              {((!!item?.price && isActive === 'paid') || (isActive === 'free' && !item.price)) && <div className="flex justify-between my-2 special-addon-option">
                <div className="flex items-center ">
                  <Form.Check
                    type="checkbox"
                    className="quotation-checkbox"
                    value={item?.id}
                    checked={selectedSpecialAddon?.includes(item?.id)}
                    onChange={(e) => {
                      if(!show) return;
                      if (e.target.checked) {
                        setSelectedSpecialAddon([...selectedSpecialAddon, e.target.value]);
                      } else {
                        setSelectedSpecialAddon(selectedSpecialAddon.filter((addons) => addons !== e.target.value));
                      }
                    }}
                  />
                  <p className="mb-0 mx-1 p">{item?.name}</p>
                </div>
                <div>
                  <p className="mb-0 mx-1">₹{item?.price}</p>
                </div>
              </div>}
              </React.Fragment>
              
            );
          })}
          <div className="flex justify-between items-center my-3">
            <button
              className="rounded px-4 h-[40px] apply-btn"
              onClick={() => {
                handleSumbmit(selectedSpecialAddon);
                setIsToggle(prev => !prev)
              }}
            >
              Apply
            </button>
            <button
              className="underline mx-1"
              onClick={() => {
                setSelectedSpecialAddon([]);
              }}
            >
              Clear Selection
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default SpecialAddon;
